import { ListItemButton as MuiListItemButton } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledListItemButton = styled(MuiListItemButton)(({ theme }) => ({
  paddingTop: "10px",
  paddingBottom: "10px",
  marginBottom: "8px",
  border: `0.5px solid ${theme.palette_custom.lightBlue}`,
  borderRadius: "2px",
}));

const ListItemButton = ({ ...props }) => {
  return <StyledListItemButton {...props} />;
};

export default ListItemButton;
